import { render, staticRenderFns } from "./productOrderDetails.vue?vue&type=template&id=ad370114&scoped=true&"
import script from "./productOrderDetails.vue?vue&type=script&lang=js&"
export * from "./productOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad370114",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad370114')) {
      api.createRecord('ad370114', component.options)
    } else {
      api.reload('ad370114', component.options)
    }
    module.hot.accept("./productOrderDetails.vue?vue&type=template&id=ad370114&scoped=true&", function () {
      api.rerender('ad370114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/productOrderDetails.vue"
export default component.exports